import { createElement } from 'react';
import { DigitalFlop } from '@jiaminghi/data-view-react';
function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
const DataVDigitalFlop = (props) => {
    const { thousands, style, CRenderStyle, ...rest } = props;
    const config = {
        ...(thousands
            ? {
                formatter: numberWithCommas,
            }
            : {}),
        ...rest,
        style: {
            ...CRenderStyle,
        },
    };
    return createElement(DigitalFlop, { config: config, style: { ...style } });
};
export default DataVDigitalFlop;
